import { useState, useEffect, useRef } from 'react'
import './App.css'

function App() {
  const [question, setQuestion] = useState('');
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  // 1. Create a ref for the end of the message list
  const chatEndRef = useRef(null);

  // 2. Scroll to bottom function
  const scrollToBottom = () => {
    chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  // 3. Trigger scroll whenever messages array or loading state changes
  useEffect(() => {
    scrollToBottom();
  }, [messages, loading]);

  const askAI = async () => {
    if (!question.trim()) return;

    const userMessage = { sender: 'user', text: question };
    setMessages((prev) => [...prev, userMessage]);
    setQuestion('');
    setLoading(true);

    try {
      //const response = await fetch(`http://localhost:8080/api/chat/ask?message=${encodeURIComponent(userMessage.text)}`);
      const response = await fetch(`/api/chat/ask?message=${encodeURIComponent(userMessage.text)}`);
      const data = await response.json();
      
      const aiMessage = { sender: 'ai', text: data.reply };
      setMessages((prev) => [...prev, aiMessage]);
    } catch (error) {
      const errorMessage = { 
        sender: 'ai', 
        text: "Error: Could not reach the server. Make sure Spring Boot is running." 
      };
      setMessages((prev) => [...prev, errorMessage]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !loading) {
      askAI();
    }
  };

  return (
    <div className="chat-container">
      <h1>Resume AI Chat</h1>
      
      <div className="chat-window">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.sender}`}>
            <span className="sender-label">
              {msg.sender === 'user' ? 'You: ' : 'AI: '}
            </span>
            {msg.text}
          </div>
        ))}
        {loading && <p className="loading-text">Thinking...</p>}
        
        {/* 4. Invisible anchor div at the bottom of the list */}
        <div ref={chatEndRef} />
      </div>

      <div className="input-area">
        <input 
          type="text" 
          value={question} 
          onChange={(e) => setQuestion(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="What is the candidate's strongest skill?"
        />
        <button onClick={askAI} disabled={loading}>
          {loading ? '...' : 'Ask'}
        </button>
      </div>
    </div>
  )
}

export default App
